import { render, staticRenderFns } from "./SystemLayout.vue?vue&type=template&id=68c10eb7&scoped=true&"
import script from "./SystemLayout.vue?vue&type=script&lang=js&"
export * from "./SystemLayout.vue?vue&type=script&lang=js&"
import style0 from "./SystemLayout.vue?vue&type=style&index=0&id=68c10eb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c10eb7",
  null
  
)

export default component.exports